import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import Axios from 'axios';
import ReactHtmlParser from 'react-html-parser';
import {BASE} from '../api/api'
import { List } from 'react-content-loader'



class PeopleWiki extends Component {
    constructor(props) {
        super(props);
        this.state={
          people:'',
          nid:props.match.params.nid,
          loginred:'/login?redir='+props.location.pathname
     
        }
      }
      signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        window.location.href = this.state.loginred
    
      }
    
    
      refreshexp(){
        let s = new Date();
        s.setSeconds(s.getSeconds()+1800);
        localStorage.setItem('expiryref', s)
      }
    
    
      checkexpiry(){
        if(localStorage.getItem('expiryref')){
          let expref=Date.parse(localStorage.getItem('expiryref'))
          let s = new Date();
          if(s>expref){
            // this.fillalert('Session Expired!Logging Out')
              this.signout()
          }
          else{
            this.refreshexp()
          }
          
        }
        else{
          // this.fillalert('Session Expired!Logging Out')
          this.signout()
           
      }
      }
    
      // componentWillMount(){
      //   if(this.state.token)
      //       this.checkexpiry()
      // }
      checklogin(){
        let dt = localStorage.getItem('token')
        if (!dt || dt == null) {
          window.location.href = this.state.loginred
        }
        else
        this.checkexpiry()
          return true
    
      }
      componentWillMount() {
        this.topFunction()
         
                Axios.get(BASE+'jsonapi/node/biographies?include=field_bioimage&filter[drupal_internal__nid]='+this.state.nid)
    
                .then((data) => {  
                  console.log(data.data.data[0],"url")
    
                  this.setState({
                    people:data.data.data[0].attributes,    
                })
    
                })
                
          
      }
      topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
render() {

    
  if(this.checklogin())
    return (
        <div className='peoplewiki'>
        <Header/>
        {/* <div>
            <img src={this.state.bioimg} height='300' alt='bioimg'/>
            <div>{this.state.people.title}</div>
        </div> */}
        <body className="wiki" >
    
         {this.state.people? <div className="main-content">
            <div className="container">
              <div className="row">
                <div className="node-wiki node">
                  {this.state.bioimg?<div className="group-left">
                    <div className="field-name-field-thumbnail">
                      <img src={this.state.bioimg} alt="CIS" />
                    </div>
                  </div>:''}
                  <div style={{width:this.state.bioimg?'':'100%'}} className="group-middle">
                    <div className="field-name-title">
                      <div className='booktitle_rea'>{this.state.people.title}</div>
                    </div>
                    
                    <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                      <div className="field-items">
                        <div className="field-item even" property="content:encoded">
                        {this.state.people.body ? ReactHtmlParser(this.state.people.body.processed):''}

                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>:<List/>}
          
          
    
  </body>


        <div><Footer/></div>
        </div>
    )
    // else {
    //   return <Redirect to={'/search/'+this.state.keyword} />;
    // }

}
}


export default PeopleWiki;
